export interface WorkItem{
  title:string
  name:string
  component:string
  src:string
  imgs:string[],
  chips:string[]
}
class Store{
  emptyWork:WorkItem = {
    title:'',
    name:'empty',
    component:'div',
    src:'',
    imgs:[],
    chips:[],
  }
  works:WorkItem[] = [
    {
      title:'Connect by happiness',
      name:'connect-by-happiness',
      src:require('@/assets/works/connect-by-happiness_1.png'),
      imgs:[
        require('@/assets/works/connect-by-happiness_1.png'),
        require('@/assets/works/connect-by-happiness_2.png'),
        require('@/assets/works/connect-by-happiness_3.png'),
        require('@/assets/works/connect-by-happiness_4.png'),
      ],
      component:'work-happiness',
      chips:[
        'Web','Game','TypeScript','Serverless',
      ],
    },
    {
      title:'コッピーコレクション',
      name:'coppieee-collection',
      component:'work-collection',
      src:require('@/assets/works/collection-coppieee-com_1.png'),
      imgs:[
        require('@/assets/works/collection-coppieee-com_1.png'),
        require('@/assets/works/collection-coppieee-com_2.png'),
      ],
      chips:[
        'Web','TypeScript','Vue.js',
      ],
    },
  ]
  _worksMap:Map<string,WorkItem> = new Map()
  constructor(){
    for(const x of this.works){
      this._worksMap.set(x.name,x)
    }
  }
  getWork(name:string){
    return this._worksMap.get(name)
  }
}
export const store = new Store()
